import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasTetuan() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Tetuán, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas rápidas y económicas en Tetuán y zona norte de Madrid</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/carousel-5.webp"
            alt="Mudanzas en Tetuán"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          <strong>Tetuán</strong> es uno de los distritos con más carácter de Madrid. Su diversidad arquitectónica, desde edificios históricos hasta bloques modernos, hace que cada mudanza sea única. En Britosa Mudanzas conocemos Tetuán al detalle y ofrecemos soluciones adaptadas a cada tipo de vivienda.
        </p>

        <h2>Mudanzas adaptadas a Tetuán</h2>
        <p>
          Ya sea que te mudes a un piso en Bravo Murillo, a un ático en Castellana o a una vivienda en las zonas residenciales del norte de Tetuán, nuestro equipo tiene la experiencia necesaria para hacerlo sin contratiempos.
        </p>
        <ul>
          <li>Mudanzas económicas para estudiantes y jóvenes profesionales.</li>
          <li>Mudanzas familiares en zonas residenciales.</li>
          <li>Traslados de comercios y locales en Bravo Murillo.</li>
          <li>Montacargas para edificios sin ascensor o con patios estrechos.</li>
        </ul>

        <h2>Barrios de Tetuán que cubrimos</h2>
        <p>
          Bellas Vistas, Cuatro Caminos, Castillejos, Almenara, Valdeacederas, Berruguete y todas las zonas del distrito de Tetuán.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Presupuesto para tu mudanza en Tetuán</h3>
          <p style={{ marginBottom: "1rem" }}>
            Precios competitivos para el distrito de Tetuán. Presupuesto en 24h.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          <a href="tel:+34691604880">691 60 48 80</a> · Todos los días 8:00 – 22:00
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Tetuán",
          "description": "Mudanzas rápidas y económicas en Tetuán, Madrid. Todas las zonas del distrito.",
          "url": "https://mudanzasbritosa.com/mudanzas-tetuan",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Tetuán, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.4603,
            "longitude": -3.6978
          },
          "areaServed": {
            "@type": "City",
            "name": "Tetuán"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
